module.exports = __webpack_public_path__ + "img/illu-scale-top.b932830f.svg";